var _excluded = ["breadcrumbs", "className"],
  _excluded2 = ["title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import { arrayOf, node, shape, string } from "prop-types";
import React from "react";
import { Link } from "#library/components/Link/Link";
import { Text, TEXT_TYPES } from "#library/components/Text/Text";
import styles from "./BreadcrumbTrail.module.css";
var BreadcrumbTrail = function BreadcrumbTrail(_ref) {
  var breadcrumbs = _ref.breadcrumbs,
    className = _ref.className,
    restProps = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("nav", _extends({
    className: className
  }, restProps), /*#__PURE__*/React.createElement("ol", {
    className: styles["jds-BreadcrumbTrail__list"]
  }, breadcrumbs.map(function (_ref2, index) {
    var title = _ref2.title,
      itemRestProps = _objectWithoutProperties(_ref2, _excluded2);
    var itemContent = null;
    if (index === breadcrumbs.length - 1) {
      itemContent = /*#__PURE__*/React.createElement(Text, {
        tag: "span",
        type: TEXT_TYPES.SMALL
      }, title);
    } else {
      itemContent = /*#__PURE__*/React.createElement(Link, _extends({
        className: styles["jds-BreadcrumbTrail__link"],
        minor: true
      }, itemRestProps), title);
    }
    return /*#__PURE__*/React.createElement("li", {
      key: title,
      className: styles["jds-BreadcrumbTrail__item"]
    }, itemContent);
  })));
};
BreadcrumbTrail.propTypes = {
  breadcrumbs: arrayOf(shape({
    title: node.isRequired
  })).isRequired,
  className: string
};
BreadcrumbTrail.defaultProps = {
  className: null
};
export { BreadcrumbTrail };